import * as React from 'react'

import { useProductListSelectionCtx } from '../contexts/ProductListSelectionProvider'
import { CategoryNavigation } from './CategoryNavigation'

type TCategories = PropsOf<typeof CategoryNavigation>['categories']

type TProps = NoChildren & {
  /**
   * product categories to choose from
   */
  productCategories: TCategories
  /**
   * whether the screen is mobile
   */
  isMobile?: boolean
  /**
   * whether the screen is tablet or mobile
   */
  isTabletOrMobile?: boolean
}

/**
 * Navigation buttons (RollingOptions) for product categories that are rendered in the menu list.
 */
export const ProductCategoryNavigation: React.FC<TProps> = ({
  isMobile,
  isTabletOrMobile,
  productCategories,
}) => {
  const { selectedId, scrollToCategoryWithoutObserver } = useProductListSelectionCtx()

  const bgColor: PropsOf<typeof CategoryNavigation>['bgColor'] = isMobile
    ? `inputOnCard`
    : `inputOnPrimary`

  return (
    <CategoryNavigation
      bgColor={bgColor}
      selectedId={selectedId}
      shadow={isMobile ? `none` : `light`}
      onSelection={scrollToCategoryWithoutObserver}
      categories={productCategories}
      scrollOverflowId={isTabletOrMobile ? `productListButtons` : undefined}
    />
  )
}
